export default __webpack_public_path__ + "static/media/page-comments.0cb66928.JPG";